// @ts-strict

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../authentication/auth.service';
import { GetUserBasicDataService } from '@services/get-user-basic-data/get-user-basic-data.service';
import { map, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(public authService: AuthService, public router: Router, public getUserDataService: GetUserBasicDataService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    if (!this.authService.isLoggedIn()) {
      if (!this.router.url.includes('auth/login')) {
        this.router.navigate(['auth/login'], { queryParams: { returnUrl: state.url } });
      }

      return false;
    } else {
      return this.getUserDataService.getBasicUserInfo().pipe(
        shareReplay(1),
        map(
          userInfo => {
            if (userInfo.data?.permissions?.includes('can-dashboard-access')) {
              return true;
            } else {
              if (userInfo.data?.permissions?.includes('can-user-info-register-set')) {
                this.router.navigate(['auth/register/user/activate-info']);
                return false;
              } else {
                this.authService.removeAuthTokens();
                this.router.navigate(['auth/register/email/activation']);
                return false;
              }
            }
          },
          error => {
            this.router.navigate(['auth/login']);
            return false;
          }
        )
      );
    }
  }
}
